import { useQuery } from '@tanstack/react-query'
import { supabaseApi } from '~/supabase/api'
import { Action } from '~/supabase/types'

export const GET_ACTIONS_QUERY_KEY = 'get-actions'

export const useGetActions = (stockCode: string | null) => {
  return useQuery({
    queryKey: [GET_ACTIONS_QUERY_KEY, stockCode],
    queryFn: async () => {
      if (!stockCode) {
        return []
      }

      const { data, error } = await supabaseApi
        .from('actions')
        .select('*')
        .eq('model', stockCode)
        .order('created_at', { ascending: false })

      if (error) {
        throw error
      }

      return (data ?? []) as Action[]
    },
    enabled: !!stockCode,
  })
}
